export const PHONE_DISPLAY = "(346) 318-5888";
export const PHONE_TEL = "tel:3463185888";
export const WA_URL =
    "https://wa.me/13463185888?text=Hi%2C%20I%20want%20a%20quote%20for%20my%20car";

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1566347287034-6b62f7a1f879?q=80&w=1600&auto=format&fit=crop",
    tow: "https://images.unsplash.com/photo-1602932365975-18086e1491b4?q=80&w=1400&auto=format&fit=crop",
    garage:
        "https://images.unsplash.com/photo-1760714132377-bfb0f6b3d892?q=80&w=1400&auto=format&fit=crop",
};

export const YEARS = Array.from({ length: 2026 - 1990 + 1 }, (_, i) => 2026 - i);

export const MAKES = [
    "Ford", "Chevrolet", "Toyota", "Nissan", "Honda", "RAM", "GMC", "Dodge",
    "Kia", "Hyundai", "BMW", "Mercedes-Benz", "Jeep", "Other",
];

export const SERVICE_AREAS = [
    "Downtown Houston", "The Heights", "Midtown", "Galleria / Uptown",
    "Katy", "Sugar Land", "Spring", "Cypress", "Pasadena", "Pearland",
    "The Woodlands", "Humble", "Alief", "Baytown", "Stafford", "Conroe",
];
